shadow$provide[125] = function(require,module,exports) {
var require$_DOT__SLASH_controls = require("./controls");
var require$_DOT__SLASH_cursor = require("./cursor");
var require$_DOT__SLASH_fullscreen = require("./fullscreen");
var require$_DOT__SLASH_stats = require("./stats");
var require$_DOT__SLASH_ui = require("./ui");
var require$_DOT__SLASH_vr = require("./vr");

};